import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user clicks the "Office" tab on the sign up page.
 * Event: dental_portal:office_signup:office_tab_clicked
 */
export function fireOfficeTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:office_tab_clicked', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
